import React from "react";
import "./styles.scss";

const StoryIntro = () => {
  return (
    <section className="story-intro-container">
      <div className="heading-text">Friends / passion / games</div>
      <div className="sub-title-text">
        #team #friends #mobile #games #passion
      </div>
      <div className="intro-desc-text">
        <span className="bold-text">ShiftedPixel</span> is a small Canadian
        company founded by two friends to develop the most enjoyable games in
        the world. Focusing on mobile market they brought to life such titles as
        Police Pursuit. Simple, innovative gameplay and unlimited fun is their
        motto.
      </div>
    </section>
  );
};

export default StoryIntro;
